__turbopack_context__.v({
  "chatMethod": "SupportPage-module__QC3_Xa__chatMethod",
  "supportCardsFlexBox": "SupportPage-module__QC3_Xa__supportCardsFlexBox",
});
